module.exports = __webpack_public_path__ + "static/media/Google_NewsInitiative_Lockup_White_Horizontal.338c22cd.svg";